export const defaultCodes = [
    "62143",
    "11414",
    "34991",
    "86955",
    "26986",
    "49514",
    "29859",
    "97675",
    "64499",
    "23396",
    "86537",
    "96977",
    "89182",
    "87132",
    "56986",
    "55894",
    "54518",
    "53137",
    "52797",
    "99378",
    "72211",
    "73941",
    "46552",
    "26518",
    "66338",
    "65986",
    "94877",
    "38374",
    "28234",
    "83176",
    "61144",
    "64418",
    "92639",
    "84774",
    "85891",
    "86978",
    "25268",
    "55675",
    "88451",
    "51782",
    "47333",
    "33917",
    "35485",
    "35467",
    "64482",
    "54512",
    "24369",
    "42617",
    "75366",
    "95266",
    "28882",
    "96723",
    "43963",
    "51846",
    "23978",
    "79663",
    "35428",
    "14813",
    "11572",
    "69248",
    "98858",
    "94112",
    "84225",
    "62353",
    "48224",
    "13567",
    "63363",
    "14614",
    "99425",
    "83499",
    "98622",
    "84918",
    "21737",
    "31913",
    "49985",
    "17197",
    "86273",
    "15153",
    "12287",
    "68256",
    "72382",
    "62375",
    "38229",
    "23265",
    "77996",
    "99462",
    "78751",
    "44189",
    "77439",
    "91724",
    "32248",
    "73235",
    "38218",
    "62269",
    "63374",
    "62355",
    "28393",
    "96899",
    "64582",
    "13233",
    "96392",
    "78269",
    "69231",
    "53658",
    "11952",
    "14516",
    "84844",
    "89679",
    "77672",
    "55629",
    "79751",
    "87352",
    "32215",
    "31465",
    "54414",
    "35561",
    "45613",
    "69924",
    "25338",
    "74558",
    "97725",
    "49256",
    "87627",
    "87719",
    "58984",
    "63213",
    "89462",
    "38311",
    "75324",
    "21556",
    "78878",
    "71464",
    "75319",
    "43713",
    "25895",
    "79351",
    "62457",
    "68495",
    "62429",
    "79914",
    "23811",
    "83499",
    "49361",
    "77461",
    "62788",
    "22342",
    "16364",
    "53433",
    "72552",
    "55476",
    "47319",
    "47569",
    "79453",
    "21256",
    "57869",
    "28917",
    "41858",
    "54424",
    "12981",
    "91796",
    "56735",
    "68977",
    "88567",
    "69166",
    "79221",
    "93287",
    "85451",
    "17411",
    "39487",
    "81552",
    "68157",
    "56447",
    "92441",
    "89257",
    "84625",
    "13546",
    "52136",
    "27467",
    "57694",
    "88944",
    "79274",
    "89578",
    "55495",
    "72142",
    "49513",
    "73619",
    "64685",
    "37362",
    "49367",
    "82367",
    "79273",
    "29621",
    "86626",
    "87963",
    "35337",
    "18218",
    "99647",
    "99962",
    "14186",
    "34167",
    "33387",
    "36964",
    "43948",
    "89923",
    "38718",
    "88426",
    "25195",
    "37672",
    "73696",
    "69677",
    "64355",
    "62635",
    "34778",
    "14333",
    "92322",
    "45232",
    "61476",
    "94621",
    "43593",
    "83212",
    "68782",
    "18125",
    "15498",
    "81384",
    "19892",
    "59654",
    "45577",
    "78993",
    "99649",
    "39487",
    "45819",
    "77111",
    "52563",
    "88813",
    "47766",
    "67768",
    "35627",
    "62396",
    "74545",
    "43276",
    "21746",
    "41921",
    "57663",
    "93188",
    "44211",
    "37786",
    "31931",
    "41976",
    "79846",
    "35882",
    "25538",
    "66358",
    "51769",
    "33465",
    "94986",
    "28122",
    "99962",
    "34867",
    "64263",
    "52464",
    "95291",
    "38713",
    "19569",
    "21772",
    "46493",
    "44812",
    "82242",
    "79578",
    "76589",
    "81896",
    "52665",
    "94219",
    "26888",
    "11544",
    "57584",
    "84118",
    "62357",
    "52622",
    "61188",
    "12794",
    "96536",
    "17261",
    "83341",
    "51463",
    "19836",
    "65444",
    "46166",
    "16433",
    "85143",
    "54327",
    "14167",
    "12621",
    "35655",
    "65297",
    "98783",
    "12316",
    "88694",
    "57399",
    "72569",
    "97287",
    "82911",
    "58154",
    "17372",
    "78538",
    "98458",
    "22568",
    "36967",
    "31376",
    "38434",
    "58969",
    "97293",
    "93635",
    "81518",
    "56492",
    "47341",
    "61788",
    "43944",
    "85266",
    "37149",
    "77247",
    "23893",
    "79578",
    "85349",
    "22335",
    "54694",
    "21938",
    "68277",
    "37638",
    "74217",
    "72554",
    "46972",
    "17898",
    "89164",
    "89633",
    "67648",
    "22169",
    "35883",
    "67513",
    "96491",
    "45332",
    "15598",
    "76482",
    "11768",
    "74264",
    "23479",
    "51114",
    "35327",
    "84322",
    "11778",
    "15553",
    "55233",
    "26353",
    "51231",
    "37721",
    "11838",
    "16857",
    "13736",
    "38712",
    "29143",
    "77566",
    "91315",
    "44866",
    "51856",
    "45369",
    "59438",
    "88419",
    "99878",
    "82529",
    "19287",
    "78698",
    "34798",
    "21336",
    "22459",
    "45242",
    "52853",
    "81959",
    "47282",
    "17984",
    "11946",
    "38155",
    "45651",
    "87141",
    "48585",
    "95281",
    "64342",
    "49515",
    "52744",
    "33138",
    "55699",
    "22342",
    "77214",
    "67717",
    "91256",
    "76934",
    "43298",
    "22462",
    "88779",
    "93869",
    "36185",
    "91342",
    "65367",
    "87662",
    "63991",
    "33968",
    "33726",
    "76417",
    "62228",
    "69845",
    "51233",
    "64483",
    "82389",
    "85268",
    "63597",
    "56586",
    "99947",
    "15157",
    "65964",
    "68964",
    "14289",
    "38613",
    "55922",
    "59965",
    "31914",
    "79334",
    "26384",
    "88163",
    "73122",
    "47347",
    "71638",
    "23482",
    "18522",
    "25212",
    "84478",
    "38917",
    "28351",
    "19976",
    "58255",
    "91145",
    "85371",
    "57538",
    "46415",
    "44437",
    "37144",
    "92567",
    "12722",
    "33546",
    "51528",
    "88185",
    "16492",
    "43784",
    "46924",
    "52246",
    "47375",
    "66994",
    "37434",
    "62627",
    "15464",
    "56497",
    "87552",
    "94549",
    "98284",
    "28717",
    "86868",
    "79667",
    "52155",
    "83874",
    "65413",
    "55972",
    "53326",
    "92193",
    "89764",
    "39671",
    "58259",
    "22888",
    "91383",
    "17297",
    "35817",
    "68166",
    "63371",
    "29837",
    "63522",
    "85734",
    "95743",
    "14785",
    "86655",
    "67798",
    "46989",
    "45217",
    "12835",
    "34418",
    "39242",
    "85381",
    "66934",
    "38357",
    "93223",
    "48474",
    "39221",
    "65699",
    "75972",
    "18897",
    "25823",
    "29449",
    "54271",
    "16845",
    "72753",
    "14221",
    "39479",
    "13527",
    "29271",
    "89379",
    "32299",
    "79481",
    "31683",
    "22518",
    "92176",
    "33255",
    "12853",
    "86313",
    "63993",
    "46782",
    "71264",
    "77592",
    "84858",
    "96652",
    "23293",
    "96699",
    "82274",
    "17924",
    "26527",
    "39475",
    "28295",
    "31218",
    "81837",
    "71235",
    "76372",
    "92854",
    "53944",
    "27545",
    "69179",
    "96285",
    "52627",
    "44949",
    "68889",
    "64913",
    "94584",
    "19346",
    "14779",
    "53834",
    "46268",
    "87938",
    "37172",
    "18533",
    "44752",
    "47813",
    "13144",
    "86679",
    "42335",
    "84321",
    "39238",
    "44698",
    "78774",
    "84849",
    "37346",
    "96497",
    "25962",
    "49397",
    "29169",
    "64889",
    "47352",
    "92973",
    "56495",
    "53931",
    "57287",
    "88417",
    "33627",
    "24451",
    "91475",
    "23747",
    "41191",
    "78788",
    "55352",
    "68763",
    "86431",
    "94162",
    "78847",
    "12928",
    "52837",
    "23883",
    "74941",
    "46621",
    "51544",
    "28977",
    "63497",
    "87284",
    "23295",
    "53528",
    "81987",
    "13572",
    "46755",
    "65349",
    "53593",
    "63564",
    "96719",
    "93595",
    "68236",
    "17941",
    "81218",
    "27195",
    "88335",
    "46227",
    "12135",
    "29914",
    "52362",
    "52374",
    "35523",
    "76117",
    "59153",
    "63925",
    "51774",
    "75928",
    "77168",
    "22585",
    "83296",
    "67893",
    "15476",
    "65729",
    "45586",
    "41873",
    "49816",
    "14392",
    "22958",
    "38881",
    "61523",
    "39986",
    "38414",
    "79665",
    "23678",
    "92974",
    "89366",
    "55179",
    "26666",
    "34456",
    "29392",
    "87993",
    "23146",
    "38252",
    "37545",
    "41924",
    "44823",
    "81765"
];
